(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  (function () {
    function initPolicyToc() {
      var root = document.querySelector('[data-policy]');
      if (!root) return;

      var body = root.querySelector('[data-policy-body]');
      var list = root.querySelector('[data-policy-toc-list]');
      if (!body || !list) return;

      var headings = body.querySelectorAll('h2, h3');
      if (!headings.length) return;

      var used = {};
      var items = [];

      headings.forEach(function (heading) {
        var text = (heading.textContent || '').trim();
        if (!text) return;

        var id = heading.id;
        if (!id) {
          id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
          if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
          heading.id = id;
        }

        var item = document.createElement('li');
        item.className = 'sofaworx-policy__toc-item';
        if (heading.tagName === 'H3') item.className += ' sofaworx-policy__toc-item--sub';

        var link = document.createElement('a');
        link.className = 'sofaworx-policy__toc-link';
        link.href = '#' + id;
        link.textContent = text;

        item.appendChild(link);
        list.appendChild(item);
        items.push({ id: id, heading: heading, link: link });
      });

      if (!items.length) return;

      root.classList.add('sofaworx-policy--with-toc');

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      list.addEventListener('click', function (event) {
        var link = event.target.closest('a');
        if (!link) return;
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      });

      if ('IntersectionObserver' in window) {
        var visible = {};
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.id] = entry.isIntersecting;
          });
          var current = null;
          for (var i = 0; i < items.length; i++) {
            if (visible[items[i].id]) { current = items[i].id; break; }
          }
          items.forEach(function (it) {
            if (it.id === current) it.link.classList.add('is-active');
            else it.link.classList.remove('is-active');
          });
        }, { rootMargin: '-120px 0px -70% 0px', threshold: 0 });

        items.forEach(function (it) { observer.observe(it.heading); });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPolicyToc);
    } else {
      initPolicyToc();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-collection"] && !Shopify.designMode) return;
  try {
    
  class SofaworxCollectionDescription extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-toggle]');
      const desc = this.querySelector('[data-description]');
      const labelMore = this.querySelector('[data-label-more]');
      const labelLess = this.querySelector('[data-label-less]');
      if (!toggle || !desc) return;

      // Hide the toggle if the description is already short enough not to clip
      requestAnimationFrame(() => {
        if (desc.scrollHeight <= desc.clientHeight + 4) {
          toggle.hidden = true;
        }
      });

      toggle.addEventListener('click', () => {
        const open = desc.getAttribute('aria-expanded') === 'true';
        desc.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (labelMore && labelLess) {
          labelMore.hidden = !open;
          labelLess.hidden = open;
        }
      });
    }
  }
  if (!customElements.get('sofaworx-collection-description')) {
    customElements.define('sofaworx-collection-description', SofaworxCollectionDescription);
  }

  class SofaworxSortMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.menu = this.querySelector('[data-menu]');
      if (!this.trigger || !this.menu) return;

      this.trigger.addEventListener('click', () => this.toggle());
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      };
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    toggle() {
      const open = this.trigger.getAttribute('aria-expanded') === 'true';
      open ? this.close() : this.open();
    }

    open() {
      this.trigger.setAttribute('aria-expanded', 'true');
      this.menu.hidden = false;
    }

    close() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.menu.hidden = true;
    }
  }
  if (!customElements.get('sofaworx-sort-menu')) {
    customElements.define('sofaworx-sort-menu', SofaworxSortMenu);
  }

  /* SofaworxCardSwatches lives in assets/sofaworx-card-swatches.js — it is
     shared with sofaworx-product-carousel, and a section-scoped bundle would
     only load on pages carrying this section. The <script> tag is emitted
     with the markup above. */

  class SofaworxInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl;
      this.spinner = this.querySelector('[data-spinner]');
      this.fallback = this.querySelector('[data-fallback]');
      this.grid = this.closest('.sofaworx-collection__grid-wrap')?.querySelector('[data-product-grid]');
      this.loading = false;
      if (!this.grid || !('IntersectionObserver' in window)) return;

      if (this.fallback) this.fallback.hidden = true;

      // Start fetching one viewport-ish ahead so cards are usually in place
      // before the customer reaches the bottom.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.loadNext();
          });
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      if (this.spinner) this.spinner.hidden = false;

      try {
        const response = await fetch(this.nextUrl);
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        doc.querySelectorAll('[data-product-grid] [data-product-card]').forEach((card) => {
          this.grid.appendChild(document.importNode(card, true));
        });

        const nextSentinel = doc.querySelector('sofaworx-infinite-scroll');
        this.nextUrl = nextSentinel ? nextSentinel.dataset.nextUrl : null;
        if (!this.nextUrl) this.remove();
      } catch (error) {
        // Network hiccup: surface the fallback link so the customer can
        // still continue manually.
        if (this.fallback) this.fallback.hidden = false;
        this.nextUrl = this.nextUrl || null;
      } finally {
        this.loading = false;
        if (this.spinner) this.spinner.hidden = true;
      }
    }
  }
  if (!customElements.get('sofaworx-infinite-scroll')) {
    customElements.define('sofaworx-infinite-scroll', SofaworxInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-header"] && !Shopify.designMode) return;
  try {
    
  // Cart icon → open the Horizon cart drawer instead of navigating to /cart.
  // Progressive enhancement: if no drawer is on the page (e.g. the cart
  // template), the click falls through and the link navigates normally.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var trigger = t && t.closest ? t.closest('[data-cart-drawer-open]') : null;
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    e.preventDefault();
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.showDialog === 'function') drawer.showDialog();
  });

  class SofaworxHeader extends HTMLElement {
    connectedCallback() {
      // Header height tracking — the mobile drawer (and any future
      // below-header overlay) needs to start exactly at the bottom of the
      // rendered header. Banner visibility, breakpoint changes, and dynamic
      // content can all change that height, so we measure it live.
      const updateHeaderHeight = () => {
        const h = this.getBoundingClientRect().height;
        this.style.setProperty('--sw-header-height', h + 'px');
      };
      updateHeaderHeight();
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateHeaderHeight).observe(this);
      } else {
        window.addEventListener('resize', updateHeaderHeight);
      }

      // Mega menu — click-to-toggle. Parent links never navigate; clicking a
      // top-level item opens its panel, clicking again (or outside) closes it.
      //
      // Animation contract (keep in sync with CSS submenu transition: 280ms):
      //  - Open: remove [hidden] FIRST so the panel renders in its closed
      //    visual state (opacity 0, translateY(-8px)). Use a double rAF so
      //    layout/paint settles on the closed frame, then flip [data-open]
      //    on the next frame — the transition runs from closed → open.
      //  - Close: remove [data-open] FIRST so the transition runs back to
      //    the closed visual state. Defer [hidden]=true by the transition
      //    duration so the panel can fade out before display:none hides it.
      //    A hide timer per item lets rapid open/close cancel cleanly.
      const megaItems = this.querySelectorAll('[data-mega-item]');
      const MEGA_TRANSITION_MS = 280;
      const megaHideTimers = new WeakMap();
      const cancelHideTimer = (item) => {
        const t = megaHideTimers.get(item);
        if (t) {
          clearTimeout(t);
          megaHideTimers.delete(item);
        }
      };
      const closeItem = (item) => {
        item.removeAttribute('data-open');
        const trigger = item.querySelector('[data-mega-trigger]');
        const panel = item.querySelector('[data-mega-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (!panel) return;
        cancelHideTimer(item);
        if (panel.hasAttribute('hidden')) return; // already closed
        const t = setTimeout(() => {
          if (!item.hasAttribute('data-open')) {
            panel.setAttribute('hidden', '');
          }
          megaHideTimers.delete(item);
        }, MEGA_TRANSITION_MS);
        megaHideTimers.set(item, t);
      };
      const closeAll = (except) => {
        megaItems.forEach((item) => {
          if (item !== except) closeItem(item);
        });
      };
      const open = (item) => {
        closeAll(item);
        const trigger = item.querySelector('[data-mega-trigger]');
        const panel = item.querySelector('[data-mega-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (!panel) {
          item.setAttribute('data-open', '');
          return;
        }
        cancelHideTimer(item);
        panel.removeAttribute('hidden');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.setAttribute('data-open', '');
          });
        });
      };
      megaItems.forEach((item) => {
        const trigger = item.querySelector('[data-mega-trigger]');
        const panel = item.querySelector('[data-mega-panel]');
        if (!trigger || !panel) return;
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.hasAttribute('data-open')) {
            closeItem(item);
          } else {
            open(item);
          }
        });
      });
      // Click outside the header closes any open mega panel
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) closeAll(null);
      });

      // Mobile drawer
      const toggle = this.querySelector('[data-mobile-toggle]');
      const drawer = this.querySelector('[data-mobile-drawer]');
      const backdrop = this.querySelector('[data-mobile-backdrop]');
      let lastFocused = null;
      let hideTimer = null;
      const DRAWER_TRANSITION_MS = 320; // matches CSS — keep in sync

      const openDrawer = () => {
        if (!toggle || !drawer) return;
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }
        lastFocused = document.activeElement;
        // Unhide before flipping [data-drawer-open] so the browser registers
        // the initial closed visual state (translateX(-100%), opacity 0).
        // Without this the transition is skipped and the drawer pops in.
        drawer.removeAttribute('hidden');
        if (backdrop) backdrop.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        document.body.style.overflow = 'hidden';
        // Double-rAF: lets layout/paint settle in the closed state on frame 1,
        // then on frame 2 we toggle the open state — transition runs cleanly.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setAttribute('data-drawer-open', '');
          });
        });
        // Move keyboard focus into the drawer for screen-reader / keyboard users
        requestAnimationFrame(() => {
          const firstFocusable = drawer.querySelector('a, button, summary');
          if (firstFocusable) firstFocusable.focus();
        });
      };

      const closeDrawer = () => {
        if (!toggle || !drawer) return;
        this.removeAttribute('data-drawer-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
          lastFocused = null;
        }
        // Defer hiding until the slide-out transition finishes — otherwise
        // the drawer disappears mid-animation. If the user re-opens before
        // the timer fires, openDrawer() clears it.
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          if (!this.hasAttribute('data-drawer-open')) {
            drawer.setAttribute('hidden', '');
            if (backdrop) backdrop.setAttribute('hidden', '');
          }
          hideTimer = null;
        }, DRAWER_TRANSITION_MS + 20);
      };

      if (toggle && drawer) {
        toggle.addEventListener('click', () => {
          if (this.hasAttribute('data-drawer-open')) closeDrawer();
          else openDrawer();
        });

        // Tapping a link inside the drawer closes it (navigation will follow)
        drawer.addEventListener('click', (e) => {
          if (e.target.closest('a')) closeDrawer();
        });

        // Tapping the backdrop closes the drawer
        if (backdrop) backdrop.addEventListener('click', closeDrawer);

        // Crossing into desktop breakpoint hides the toggle — close the drawer too
        const desktopMq = window.matchMedia('(min-width: 750px)');
        const handleMq = (e) => {
          if (e.matches && this.hasAttribute('data-drawer-open')) closeDrawer();
        };
        if (desktopMq.addEventListener) desktopMq.addEventListener('change', handleMq);
        else if (desktopMq.addListener) desktopMq.addListener(handleMq);
      }

      // Search panel — opens from the search icon (desktop or mobile),
      // slides down below the sticky header, runs predictive search via
      // /search/suggest.json, closes on backdrop / X / Esc / link nav.
      const searchToggles = this.querySelectorAll('[data-search-toggle]');
      const searchPanel = this.querySelector('[data-search-panel]');
      const searchBackdrop = this.querySelector('[data-search-backdrop]');
      const searchInput = searchPanel ? searchPanel.querySelector('[data-search-input]') : null;
      const searchClose = searchPanel ? searchPanel.querySelector('[data-search-close]') : null;
      const searchResults = searchPanel ? searchPanel.querySelector('[data-search-results]') : null;
      const searchForm = searchPanel ? searchPanel.querySelector('[data-search-form]') : null;
      const inlineForm = this.querySelector('[data-search-form-inline]');
      const inlineInput = this.querySelector('[data-search-input-inline]');
      const inlineCancel = this.querySelector('[data-search-cancel]');
      const desktopMq = window.matchMedia('(min-width: 750px)');
      const SEARCH_TRANSITION_MS = 320;
      let searchHideTimer = null;
      let searchLastFocused = null;
      let searchDebounce = null;
      let searchAbort = null;
      let lastQuery = '';

      const escapeHtml = (str) =>
        String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

      const renderResults = (data, query) => {
        if (!searchResults) return;
        const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResults.innerHTML = '<p class="sofaworx-header__search-empty">No products match "' + escapeHtml(query) + '".</p>';
          return;
        }
        const items = products
          .slice(0, 6)
          .map((p) => {
            const img = p.image
              ? '<img class="sofaworx-header__search-result-image" src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="56" height="56">'
              : '<span class="sofaworx-header__search-result-image" aria-hidden="true"></span>';
            const price = p.price ? '<p class="sofaworx-header__search-result-price">' + escapeHtml(p.price) + '</p>' : '';
            return (
              '<a class="sofaworx-header__search-result" href="' + escapeHtml(p.url) + '">' +
                img +
                '<div class="sofaworx-header__search-result-meta">' +
                  '<p class="sofaworx-header__search-result-name">' + escapeHtml(p.title) + '</p>' +
                  price +
                '</div>' +
              '</a>'
            );
          })
          .join('');
        searchResults.innerHTML =
          '<p class="sofaworx-header__search-status">' + products.length + ' result' + (products.length === 1 ? '' : 's') + '</p>' +
          '<div class="sofaworx-header__search-list">' + items + '</div>' +
          '<a class="sofaworx-header__search-viewall" href="/search?q=' + encodeURIComponent(query) + '&type=product">View all results &rarr;</a>';
      };

      const runSearch = (query) => {
        if (!searchResults) return;
        if (searchAbort) searchAbort.abort();
        if (typeof AbortController !== 'undefined') searchAbort = new AbortController();
        const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: searchAbort ? searchAbort.signal : undefined })
          .then((r) => r.json())
          .then((data) => {
            // Only render if the query is still current — guards against
            // race conditions where a slower earlier request resolves last.
            if (query === lastQuery) renderResults(data, query);
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            // Don't blow away results on transient network errors.
          });
      };

      // Both inline and panel inputs flow through the same handler. The
      // active input is whichever the user is typing in; the other is kept
      // in sync so closing/reopening on a different viewport keeps state.
      const handleSearchInput = (event) => {
        const source = event && event.target ? event.target : null;
        const query = source ? source.value.trim() : '';
        lastQuery = query;
        // Mirror to the other input so the value persists across viewports.
        if (source === inlineInput && searchInput) searchInput.value = source.value;
        else if (source === searchInput && inlineInput) inlineInput.value = source.value;
        if (!query) {
          if (searchResults) searchResults.innerHTML = '';
          return;
        }
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(() => runSearch(query), 180);
      };

      const openSearch = () => {
        if (!searchPanel) return;
        if (searchHideTimer) {
          clearTimeout(searchHideTimer);
          searchHideTimer = null;
        }
        searchLastFocused = document.activeElement;
        searchPanel.removeAttribute('hidden');
        if (searchBackdrop) searchBackdrop.removeAttribute('hidden');
        searchToggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
        if (inlineForm) inlineForm.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        // Double-rAF so the browser registers the closed visual state
        // before we toggle the open attribute (transition runs cleanly).
        // Focus is nested AFTER the open flip so the inline input — which
        // starts at visibility: hidden and is therefore unfocusable —
        // becomes focusable before we call .focus() on it.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setAttribute('data-search-open', '');
            requestAnimationFrame(() => {
              if (desktopMq.matches && inlineInput) {
                inlineInput.removeAttribute('tabindex');
                if (inlineCancel) inlineCancel.removeAttribute('tabindex');
                inlineInput.focus();
              } else if (searchInput) {
                searchInput.focus();
              }
            });
          });
        });
      };

      const closeSearch = () => {
        if (!searchPanel) return;
        this.removeAttribute('data-search-open');
        searchToggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        if (inlineForm) inlineForm.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (searchAbort) searchAbort.abort();
        clearTimeout(searchDebounce);
        if (searchLastFocused && typeof searchLastFocused.focus === 'function') {
          searchLastFocused.focus();
          searchLastFocused = null;
        }
        if (searchHideTimer) clearTimeout(searchHideTimer);
        searchHideTimer = setTimeout(() => {
          if (!this.hasAttribute('data-search-open')) {
            searchPanel.setAttribute('hidden', '');
            if (searchBackdrop) searchBackdrop.setAttribute('hidden', '');
            // Reset query + restore tabindex on inline (so it's not in the
            // tab order while hidden behind the menu).
            if (searchInput) searchInput.value = '';
            if (inlineInput) {
              inlineInput.value = '';
              inlineInput.setAttribute('tabindex', '-1');
            }
            if (inlineCancel) inlineCancel.setAttribute('tabindex', '-1');
            if (searchResults) searchResults.innerHTML = '';
            lastQuery = '';
          }
          searchHideTimer = null;
        }, SEARCH_TRANSITION_MS + 20);
      };

      if (searchPanel && searchToggles.length) {
        searchToggles.forEach((toggle) => {
          toggle.addEventListener('click', () => {
            if (this.hasAttribute('data-search-open')) closeSearch();
            else openSearch();
          });
        });
        if (searchClose) searchClose.addEventListener('click', closeSearch);
        if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
        if (searchInput) searchInput.addEventListener('input', handleSearchInput);
        if (inlineInput) inlineInput.addEventListener('input', handleSearchInput);
        if (inlineCancel) inlineCancel.addEventListener('click', closeSearch);
        // Click on a result navigates — close the panel first so focus
        // restores cleanly after the page change initiates.
        if (searchResults) {
          searchResults.addEventListener('click', (e) => {
            if (e.target.closest('a')) closeSearch();
          });
        }
        // Submitting either form lets the browser navigate to /search?q=…
        // — block empty queries so an empty submit doesn't dump the user
        // on a no-query results page.
        const guardSubmit = (form, input) => {
          if (!form) return;
          form.addEventListener('submit', (e) => {
            if (input && !input.value.trim()) e.preventDefault();
          });
        };
        guardSubmit(searchForm, searchInput);
        guardSubmit(inlineForm, inlineInput);

        // Re-evaluate focus + tabindex when crossing the desktop breakpoint
        // while the search is open (e.g. user rotates their device).
        const handleSearchMq = () => {
          if (!this.hasAttribute('data-search-open')) return;
          if (desktopMq.matches && inlineInput) {
            inlineInput.removeAttribute('tabindex');
            if (inlineCancel) inlineCancel.removeAttribute('tabindex');
            inlineInput.focus();
          } else if (searchInput) {
            searchInput.focus();
          }
        };
        if (desktopMq.addEventListener) desktopMq.addEventListener('change', handleSearchMq);
        else if (desktopMq.addListener) desktopMq.addListener(handleSearchMq);
      }

      // Esc closes any open mega panel, the mobile drawer, or the search
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        closeAll(null);
        if (this.hasAttribute('data-drawer-open')) closeDrawer();
        if (this.hasAttribute('data-search-open')) closeSearch();
      });

      // Announcement bar collapses on scroll — the rest of the header stays
      // sticky. Hysteresis: collapse at >120px, expand only when scrolled
      // back above 40px. The dead zone (40–120) prevents a ping-pong loop:
      // when the band collapses, the document shrinks by ~44px and the
      // browser's scroll-anchoring readjusts scrollY downward — without
      // hysteresis the new scrollY would re-trigger expand, causing a
      // glitch as the band rapidly opens and closes.
      const banner = this.querySelector('[data-banner]');
      if (banner) {
        const COLLAPSE_AT = 120;
        const EXPAND_AT = 40;
        const sync = () => {
          const y = window.scrollY || window.pageYOffset;
          const isCollapsed = this.hasAttribute('data-collapsed');
          if (!isCollapsed && y > COLLAPSE_AT) this.setAttribute('data-collapsed', '');
          else if (isCollapsed && y < EXPAND_AT) this.removeAttribute('data-collapsed');
        };
        // Initialize from the current scroll position (handles reloads while
        // the page is already scrolled — without this the bar would briefly
        // show then animate away).
        sync();
        let pending = false;
        window.addEventListener(
          'scroll',
          () => {
            if (pending) return;
            pending = true;
            requestAnimationFrame(() => {
              sync();
              pending = false;
            });
          },
          { passive: true }
        );
      }

      // Announcement carousel — cross-fade between blocks every 5s, with
      // prev/next nav, hover/focus pause, touch swipe, visibility-aware
      // pause when the tab is hidden, and prefers-reduced-motion respect.
      const carousel = this.querySelector('[data-banner-carousel]');
      if (carousel) {
        const slides = Array.from(carousel.querySelectorAll('[data-banner-slide]'));
        if (slides.length > 1) {
          const dashes = Array.from(carousel.querySelectorAll('[data-banner-dash]'));
          const ROTATE_MS = 5000;
          carousel.style.setProperty('--sw-banner-dur', ROTATE_MS + 'ms');
          const motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
          let current = 0;
          let timerId = null;

          const syncDashes = () => {
            dashes.forEach((d, i) => {
              const active = i === current;
              d.setAttribute('aria-selected', active ? 'true' : 'false');
              if (active) d.setAttribute('data-active', '');
              else d.removeAttribute('data-active');
            });
          };
          // Restart the active dash's fill from zero — removing and
          // re-adding data-active with a forced reflow re-triggers the
          // CSS animation, keeping the fill in step with a fresh timer.
          const restartDash = () => {
            const d = dashes[current];
            if (!d) return;
            d.removeAttribute('data-active');
            void d.offsetWidth;
            d.setAttribute('data-active', '');
          };
          const goTo = (rawIndex) => {
            const target = ((rawIndex % slides.length) + slides.length) % slides.length;
            if (target === current) return;
            const exiting = slides[current];
            const entering = slides[target];
            exiting.removeAttribute('aria-current');
            exiting.setAttribute('aria-hidden', 'true');
            entering.removeAttribute('aria-hidden');
            entering.setAttribute('aria-current', 'true');
            current = target;
            syncDashes();
          };

          const stop = () => {
            if (timerId) {
              clearInterval(timerId);
              timerId = null;
            }
          };
          // pause() freezes the dash fill mid-way (hover/focus); start()
          // always restarts both the timer AND the fill from zero so the
          // two never drift apart.
          const pause = () => {
            stop();
            carousel.setAttribute('data-paused', '');
          };
          const start = () => {
            stop();
            carousel.removeAttribute('data-paused');
            if (motionMq.matches) return;
            // No point rotating while the band is collapsed — pauses the
            // CPU work AND avoids a slide cross-fade running concurrently
            // with the height-collapse transition (which reads as a glitch).
            if (this.hasAttribute('data-collapsed')) return;
            restartDash();
            timerId = setInterval(() => goTo(current + 1), ROTATE_MS);
          };

          dashes.forEach((d) => {
            d.addEventListener('click', () => {
              goTo(parseInt(d.dataset.slideIndex, 10));
              start();
            });
          });

          carousel.addEventListener('mouseenter', pause);
          carousel.addEventListener('mouseleave', start);
          carousel.addEventListener('focusin', pause);
          carousel.addEventListener('focusout', start);

          // Touch swipe — horizontal threshold of 40px
          let touchStartX = 0;
          let touchActive = false;
          carousel.addEventListener(
            'touchstart',
            (e) => {
              touchStartX = e.touches[0].clientX;
              touchActive = true;
              pause();
            },
            { passive: true }
          );
          carousel.addEventListener('touchend', (e) => {
            if (!touchActive) return;
            const dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 40) {
              goTo(current + (dx < 0 ? 1 : -1));
            }
            touchActive = false;
            start();
          });

          document.addEventListener('visibilitychange', () => {
            if (document.hidden) stop();
            else start();
          });

          // React to banner collapse/expand on scroll — pause when the
          // band is hidden, resume when it's back.
          new MutationObserver(() => {
            if (this.hasAttribute('data-collapsed')) stop();
            else start();
          }).observe(this, { attributes: true, attributeFilter: ['data-collapsed'] });

          const motionListener = () => {
            if (motionMq.matches) stop();
            else start();
          };
          if (motionMq.addEventListener) motionMq.addEventListener('change', motionListener);
          else if (motionMq.addListener) motionMq.addListener(motionListener);

          start();
        }
      }
    }
  }
  if (!customElements.get('sofaworx-header')) {
    customElements.define('sofaworx-header', SofaworxHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sofaworx-hero')) {
    customElements.define('sofaworx-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        const { signal } = this.controller;
        const slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        if (!slides.length) return;
        let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        const panels = Array.from(this.querySelectorAll('[data-hero-panel]'));
        const current = this.querySelector('[data-hero-current]');
        const status = this.querySelector('[data-hero-status]');
        const toggle = this.querySelector('[data-hero-toggle]');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const editor = Boolean(window.Shopify?.designMode);
        const autoplay = this.dataset.autoplay === 'true' && slides.length > 1;
        const delay = (Number(this.dataset.autoplaySpeed) || 10) * 1000;
        let paused = motion.matches || editor;
        let hovered = false;
        let focused = this.contains(document.activeElement);

        const updateToggle = () => {
          if (!toggle) return;
          toggle.dataset.paused = String(paused);
          toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        };
        const schedule = () => {
          clearTimeout(this.timer);
          if (!autoplay || paused || hovered || focused || document.hidden || editor) return;
          this.timer = setTimeout(() => {
            go(active + 1);
            schedule();
          }, delay);
        };
        const go = (index, announce = false) => {
          active = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => {
            const selected = i === active;
            slide.classList.toggle('is-active', selected);
            slide.inert = !selected;
            slide.setAttribute('aria-hidden', String(!selected));
          });
          panels.forEach((panel) => {
            const selected = panel.dataset.blockId === slides[active].dataset.blockId;
            panel.classList.toggle('is-active', selected);
            panel.inert = !selected;
            panel.setAttribute('aria-hidden', String(!selected));
          });
          if (current) current.textContent = String(active + 1).padStart(2, '0');
          if (status && announce) {
            const title = panels.find((panel) => panel.dataset.blockId === slides[active].dataset.blockId)?.querySelector('.sofaworx-hero__headline')?.textContent.trim() || '';
            status.textContent = `${active + 1} / ${slides.length}: ${title}`;
          }
        };
        const navigate = (direction) => {
          go(active + direction, true);
          schedule();
        };
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => navigate(-1), { signal });
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => navigate(1), { signal });
        toggle?.addEventListener('click', () => {
          paused = !paused;
          updateToggle();
          schedule();
        }, { signal });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          hovered = true;
          schedule();
        }, { signal });
        this.addEventListener('pointerleave', () => { hovered = false; schedule(); }, { signal });
        this.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
        this.addEventListener('focusout', (event) => {
          focused = this.contains(event.relatedTarget);
          schedule();
        }, { signal });
        document.addEventListener('visibilitychange', schedule, { signal });
        motion.addEventListener('change', () => {
          if (motion.matches) paused = true;
          updateToggle();
          schedule();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1) {
            paused = true;
            go(index, true);
            updateToggle();
            schedule();
          }
        }, { signal });
        go(active);
        updateToggle();
        this.dataset.ready = '';
        schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.sofaworx-hotspots');

    sections.forEach(function (section) {
      var viewport = section.querySelector('[data-hotspots-viewport]');
      if (!viewport) return;

      var dots = viewport.querySelectorAll('[data-hotspot-index]');
      var cards = viewport.querySelectorAll('[data-hotspot-card]');
      var prevBtn = viewport.querySelector('[data-hotspot-prev]');
      var nextBtn = viewport.querySelector('[data-hotspot-next]');
      var activeIndex = -1;

      function closeAll() {
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        cards.forEach(function (c) {
          c.classList.remove('is-visible');
          c.setAttribute('aria-hidden', 'true');
        });
        activeIndex = -1;
      }

      function openHotspot(index) {
        if (index < 0 || index >= dots.length) return;

        var wasActive = activeIndex === index;
        closeAll();
        if (wasActive) return;

        activeIndex = index;
        dots[index].classList.add('is-active');

        var card = viewport.querySelector('[data-hotspot-card="' + index + '"]');
        if (card) {
          card.classList.add('is-visible');
          card.setAttribute('aria-hidden', 'false');
          clampCard(card);
        }
      }

      function clampCard(card) {
        var vRect = viewport.getBoundingClientRect();
        var cRect = card.getBoundingClientRect();

        var overflowBottom = cRect.bottom - vRect.bottom;
        if (overflowBottom > 0) {
          var currentTop = parseFloat(card.style.top) || 0;
          var shiftPct = (overflowBottom / vRect.height) * 100;
          card.style.top = Math.max(5, currentTop - shiftPct) + '%';
        }

        var overflowTop = vRect.top - cRect.top;
        if (overflowTop > 0) {
          var currentTop2 = parseFloat(card.style.top) || 0;
          var shiftPct2 = (overflowTop / vRect.height) * 100;
          card.style.top = (currentTop2 + shiftPct2) + '%';
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          openHotspot(parseInt(dot.getAttribute('data-hotspot-index'), 10));
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var next = activeIndex <= 0 ? dots.length - 1 : activeIndex - 1;
          openHotspot(next);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var next = activeIndex >= dots.length - 1 ? 0 : activeIndex + 1;
          openHotspot(next);
        });
      }

      viewport.addEventListener('click', function (e) {
        if (!e.target.closest('[data-hotspot-index]') && !e.target.closest('[data-hotspot-card]') && !e.target.closest('.sofaworx-hotspots__arrow')) {
          closeAll();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (activeIndex === -1) return;
        if (e.key === 'Escape') closeAll();
        if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
        if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-new-ranges"] && !Shopify.designMode) return;
  try {
    
  // Silent lifestyle loop: plays only while on screen, starts paused for
  // reduced-motion users, and keeps the visitor's pause across scrolls.
  if (!customElements.get('sofaworx-loop-video')) {
    customElements.define('sofaworx-loop-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-video-toggle]');
        if (!this.video || !this.toggle) return;
        this.video.muted = true;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = false;
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        });
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      sync() {
        if (this.visible && !this.paused) {
          this.video.play().catch(() => {
            this.paused = true;
            this.render();
          });
        } else {
          this.video.pause();
        }
        this.render();
      }

      render() {
        this.toggle.dataset.paused = String(this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? 'Play video' : 'Pause video');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class SofaworxProductCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-carousel-scroller]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.progress = this.querySelector('[data-carousel-progress]');
      if (!this.scroller) return;

      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      this.prev?.addEventListener('click', () => this.step(-1), { signal });
      this.next?.addEventListener('click', () => this.step(1), { signal });
      this.scroller.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-swatch]');
        const label = swatch?.closest('[data-product-card]')?.querySelector('[data-carousel-fabric]');
        if (label) label.textContent = swatch.getAttribute('title');
      }, { signal });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.scroller);
      } else {
        this.onResize = () => this.scheduleUpdate();
        window.addEventListener('resize', this.onResize);
      }

      this.update();
      if (this.dataset.sourceUrl) {
        this.loadSortedProducts(signal);
      } else {
        this.prepareVariants(this.scroller).then(() => this.randomizeVariants(this.scroller));
      }
    }

    async prepareVariants(root) {
      if (!root.querySelector('sofaworx-base-variants')) return;
      await customElements.whenDefined('sofaworx-base-variants');
      if (root.ownerDocument !== document) document.adoptNode(root);
      await customElements.get('sofaworx-base-variants').prepareRoot(root);
    }

    randomizeVariants(root) {
      if (!this.hasAttribute('data-randomize-variants')) return;
      root.querySelectorAll('[data-product-card]').forEach((card) => {
        const data = card.querySelector('[data-carousel-variants]');
        if (!data || card.hasAttribute('data-finish-initialized')) return;
        card.setAttribute('data-finish-initialized', '');
        const variants = JSON.parse(data.textContent);
        // Repeated images should not give a finish extra weight in the draw.
        const finishes = [...new Map(variants.map(variant => [variant.image, variant])).values()];
        const image = card.querySelector('[data-card-img]');
        if (!finishes.length || !image) return;
        const chosen = finishes[Math.floor(Math.random() * finishes.length)];
        image.src = chosen.image;
        image.removeAttribute('srcset');
        card.querySelectorAll('[data-card-link]').forEach(link => { link.href = chosen.url; });
        const label = card.querySelector('[data-carousel-fabric]');
        if (label) label.textContent = chosen.title;

        const swatches = [...card.querySelectorAll('[data-swatch]')];
        let selected = swatches.find(swatch => swatch.dataset.variantUrl === chosen.url);
        // Keep a selected finish visible even when it falls outside the first
        // few editor-configured swatches. The number of visible tiles stays fixed.
        if (!selected && swatches.length) {
          selected = swatches[swatches.length - 1];
          selected.dataset.variantUrl = chosen.url;
          selected.dataset.image = chosen.image;
          delete selected.dataset.srcset;
          selected.title = chosen.title;
          selected.setAttribute('aria-label', chosen.title);
          const thumbnail = document.createElement('img');
          const thumbnailUrl = new URL(chosen.image, window.location.origin);
          thumbnailUrl.searchParams.set('width', '96');
          thumbnail.src = thumbnailUrl.href;
          thumbnail.alt = chosen.title;
          thumbnail.loading = 'lazy';
          thumbnail.className = 'sofaworx-pcar__swatch-img';
          selected.replaceChildren(thumbnail);
        }
        swatches.forEach(swatch => swatch.setAttribute('aria-pressed', String(swatch === selected)));
      });
    }

    async loadSortedProducts(signal) {
      const status = this.querySelector('[data-carousel-status]');
      const url = new URL(this.dataset.sourceUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      // Preserve the unpublished theme when reviewing through a preview URL.
      const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      const request = new AbortController();
      const abortRequest = () => request.abort();
      signal.addEventListener('abort', abortRequest, { once: true });
      const timeout = setTimeout(abortRequest, 15000);
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Unable to load collection');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sorted = html.querySelector('sofaworx-product-carousel[data-sort-ready="true"] .sofaworx-pcar__track');
        if (!sorted?.querySelector('[data-product-card]')) throw new Error('No sorted products returned');
        if (!this.isConnected || signal.aborted) return;
        await this.prepareVariants(sorted);
        if (!this.isConnected || signal.aborted) return;
        this.randomizeVariants(sorted);
        this.scroller.querySelector('.sofaworx-pcar__track').replaceChildren(...sorted.children);
        status?.remove();
        delete this.dataset.sourceUrl;
        this.update();
      } catch {
        if (this.isConnected && status) {
          status.querySelector('[data-carousel-skeleton]')?.remove();
          status.classList.add('sofaworx-pcar__load-status--error', 'page-width');
          status.querySelector('[data-carousel-status-text]').classList.remove('visually-hidden');
          status.querySelector('[data-carousel-status-text]').textContent = 'Browse the collection to see our best sellers.';
          status.querySelector('[data-carousel-fallback]').hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        signal.removeEventListener('abort', abortRequest);
        this.removeAttribute('aria-busy');
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    /* Scroll and resize both fire in bursts; collapse them onto one frame so
       the arrow state is computed once per paint rather than per event. */
    scheduleUpdate() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    /* One "page" is the visible width, so a click advances by however many
       cards happen to be on screen at the current breakpoint. */
    step(direction) {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.scroller.scrollBy({ left: direction * this.scroller.clientWidth, behavior });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
      // Sub-pixel layout means scrollLeft rarely lands exactly on the end.
      const overflows = scrollWidth - clientWidth > 1;
      if (this.progress) {
        this.progress.hidden = !overflows;
        this.progress.style.setProperty('--sw-scroll-size', `${clientWidth / scrollWidth * 100}%`);
        this.progress.style.setProperty('--sw-scroll-offset', `${Math.max(0, Math.min(scrollLeft, scrollWidth - clientWidth)) / clientWidth * 100}%`);
      }

      [this.prev, this.next].forEach((button) => {
        if (button) button.hidden = !overflows;
      });
      if (!overflows) return;

      if (this.prev) this.prev.disabled = scrollLeft <= 1;
      if (this.next) this.next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
    }
  }

  if (!customElements.get('sofaworx-product-carousel')) {
    customElements.define('sofaworx-product-carousel', SofaworxProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-product"] && !Shopify.designMode) return;
  try {
    
  class SofaworxProduct extends HTMLElement {
    connectedCallback() {
      const variantsScript = this.querySelector('[data-variants]');
      if (variantsScript) {
        try {
          this.variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
          this.variants = [];
        }
      } else {
        this.variants = [];
      }
      // Two prices share [data-price-current] — the header price and the
      // sticky buy-bar price — so update both on native variant changes.
      this.priceEls = this.querySelectorAll('[data-price-current]');
      this.idInput = this.querySelector('[data-variant-id-input]');
      this.atcBtn = this.querySelector('[data-atc]');
      this.mainImg = this.querySelector('[data-main-img]');

      // Quantity steppers — display input is outside the form; sync to hidden form input
      this.qtyHidden = this.querySelector('[data-qty-hidden]');
      const qtyDisplay = this.querySelector('[data-qty-input]');
      const syncQty = (value) => {
        const v = Math.max(1, parseInt(value, 10) || 1);
        if (qtyDisplay) qtyDisplay.value = v;
        if (this.qtyHidden) this.qtyHidden.value = v;
      };
      this.querySelectorAll('[data-qty-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!qtyDisplay) return;
          const step = parseInt(btn.getAttribute('data-qty-step'), 10);
          syncQty((parseInt(qtyDisplay.value, 10) || 1) + step);
        });
      });
      if (qtyDisplay) {
        qtyDisplay.addEventListener('input', () => syncQty(qtyDisplay.value));
      }

      // ATC lives outside the form. Forward its click to the hidden in-form
      // submit proxy so the Mira configurator (which binds to the first submit
      // button inside the form) intercepts it. Falls back to native submit when
      // Mira isn't active.
      this.querySelectorAll('[data-submit-form]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const proxy = this.querySelector('[data-mira-atc-proxy]');
          if (proxy) {
            proxy.click();
            return;
          }
          const form = this.querySelector('[data-product-form]');
          if (!form) return;
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      // Option buttons → recompute selected variant
      this.selectedOptions = {};
      this.querySelectorAll('[data-option-position]').forEach((btn) => {
        const position = parseInt(btn.getAttribute('data-option-position'), 10);
        const value = btn.getAttribute('data-option-value');
        if (btn.classList.contains('sofaworx-product__option-btn--selected')) {
          this.selectedOptions[position] = value;
        }
        btn.addEventListener('click', () => {
          this.querySelectorAll('[data-option-position="' + position + '"]').forEach((b) => {
            b.classList.remove('sofaworx-product__option-btn--selected');
          });
          btn.classList.add('sofaworx-product__option-btn--selected');
          this.selectedOptions[position] = value;
          // Update label in the summary
          const label = this.querySelector('[data-option-value="' + position + '"]');
          if (label) label.textContent = value;
          this.recomputeVariant();
        });
      });

      // Thumbs
      this.querySelectorAll('[data-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.querySelectorAll('[data-thumb]').forEach((b) => b.removeAttribute('data-active'));
          btn.setAttribute('data-active', '');
          if (this.mainImg) {
            const src = btn.getAttribute('data-src');
            const srcset = btn.getAttribute('data-srcset');
            if (src) this.mainImg.setAttribute('src', src);
            if (srcset) this.mainImg.setAttribute('srcset', srcset);
          }
        });
      });
    }

    recomputeVariant() {
      const optionsArr = [];
      Object.keys(this.selectedOptions)
        .map(Number)
        .sort((a, b) => a - b)
        .forEach((pos) => optionsArr.push(this.selectedOptions[pos]));
      const match = (this.variants || []).find((v) => {
        const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
        if (vOpts.length !== optionsArr.length) return false;
        return vOpts.every((opt, i) => opt === optionsArr[i]);
      });
      if (!match) return;
      if (this.idInput) this.idInput.value = match.id;
      if (this.priceEls) {
        this.priceEls.forEach((el) => {
          el.textContent = this.formatMoney(match.price);
        });
      }
      if (this.atcBtn) {
        if (match.available) {
          this.atcBtn.removeAttribute('disabled');
          this.atcBtn.textContent = 'Add to Cart';
        } else {
          this.atcBtn.setAttribute('disabled', '');
          this.atcBtn.textContent = 'Sold Out';
        }
      }
      // Broadcast the new selection so other components stay in sync — notably
      // the Request-a-Quote modal (assets/order-by-phone.js), which listens for
      // the theme's 'variant:update' event (see assets/events.js). Omit
      // data.productId so document-level listeners that skip on a productId
      // mismatch still process this update.
      this.dispatchEvent(
        new CustomEvent('variant:update', {
          bubbles: true,
          detail: { resource: match, sourceId: 'sofaworx-product', data: {} },
        })
      );
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const [intPart, decPart] = value.split('.');
      return 'R ' + intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + decPart;
    }
  }
  if (!customElements.get('sofaworx-product')) {
    customElements.define('sofaworx-product', SofaworxProduct);
  }

  class SofaworxProductDescription extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-toggle]');
      const desc = this.querySelector('[data-description]');
      const labelMore = this.querySelector('[data-label-more]');
      const labelLess = this.querySelector('[data-label-less]');
      if (!toggle || !desc) return;

      // Hide toggle if description doesn't overflow
      requestAnimationFrame(() => {
        if (desc.scrollHeight <= desc.clientHeight + 4) {
          toggle.hidden = true;
        }
      });

      toggle.addEventListener('click', () => {
        const open = desc.getAttribute('aria-expanded') === 'true';
        desc.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (labelMore && labelLess) {
          labelMore.hidden = !open;
          labelLess.hidden = open;
        }
      });
    }
  }
  if (!customElements.get('sofaworx-product-description')) {
    customElements.define('sofaworx-product-description', SofaworxProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-review-spotlight"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-spotlight-toggle]').forEach((button) => {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    const target = document.getElementById(button.getAttribute('aria-controls'));
    if (!target) return;
    button.addEventListener('click', () => {
      const open = target.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.labelClose : button.dataset.labelOpen;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-reviews-page"] && !Shopify.designMode) return;
  try {
    
  /*
   * Client-side JS pagination for sofaworx-reviews-page.
   * Mirrors the Pagination component's router.push(`/reviews?page=X`) UX
   * as closely as a no-build Liquid section allows.
   * Scoped: multiple instances on the page work independently.
   */
  (function () {
    'use strict';

    function initReviewsPage(section) {
      var grid = section.querySelector('.sofaworx-reviews-page__grid');
      if (!grid) return;

      var perPage = parseInt(grid.dataset.perPage, 10) || 6;
      var totalPages = parseInt(grid.dataset.totalPages, 10) || 1;
      var currentPage = 1;

      var cards = Array.prototype.slice.call(
        grid.querySelectorAll('.sofaworx-reviews-page__card')
      );
      var pagination = section.querySelector('.sofaworx-reviews-page__pagination');
      var prevBtn = pagination && pagination.querySelector('.sofaworx-reviews-page__pag-prev');
      var nextBtn = pagination && pagination.querySelector('.sofaworx-reviews-page__pag-next');
      var numBtns = pagination
        ? Array.prototype.slice.call(
            pagination.querySelectorAll('.sofaworx-reviews-page__pag-num')
          )
        : [];

      function showPage(page) {
        currentPage = Math.max(1, Math.min(page, totalPages));

        cards.forEach(function (card) {
          var cardPage = parseInt(card.dataset.page, 10);
          var visible = cardPage === currentPage;
          card.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });

        numBtns.forEach(function (btn) {
          var active = parseInt(btn.dataset.page, 10) === currentPage;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-current', active ? 'page' : 'false');
        });

        if (prevBtn) prevBtn.disabled = currentPage === 1;
        if (nextBtn) nextBtn.disabled = currentPage === totalPages;
      }

      // Wire page number buttons
      numBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          showPage(parseInt(btn.dataset.page, 10));
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          showPage(currentPage - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          showPage(currentPage + 1);
        });
      }

      // Initialise: show page 1
      showPage(1);
    }

    document.querySelectorAll('.sofaworx-reviews-page').forEach(function (section) {
      initReviewsPage(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-sale-hero"] && !Shopify.designMode) return;
  try {
    
  class SofaworxSaleHero extends HTMLElement {
    connectedCallback() {
      this.initCountdown();
      this.initSticky();
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
    }

    initCountdown() {
      const el = this.querySelector('[data-sale-hero-countdown]');
      if (!el) return;
      const ends = Date.parse(el.dataset.ends);
      if (Number.isNaN(ends)) return;
      const textEl = this.querySelector('[data-sale-hero-deadline-text]');
      const prefix = el.dataset.prefix || 'Sale ends in';
      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        const diff = ends - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          if (textEl) textEl.hidden = false;
          clearInterval(this.timer);
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        el.textContent = d > 0
          ? `${prefix} ${d}d ${pad(h)}h ${pad(m)}m`
          : `${prefix} ${pad(h)}h ${pad(m)}m ${pad(s)}s`;
        el.hidden = false;
        if (textEl) textEl.hidden = true;
      };

      tick();
      this.timer = setInterval(tick, 1000);
    }

    initSticky() {
      const bar = this.querySelector('[data-sale-hero-sticky]');
      const cta = this.querySelector('[data-sale-hero-cta]');
      if (!bar || !cta || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      // Watch every sale-hero button on the page (the closing band has one
      // too): show the bar once the hero button has scrolled above the
      // viewport, and hide it again while any other button is on screen.
      const ctas = Array.from(document.querySelectorAll('[data-sale-hero-cta]'));
      const visible = new Set();
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          const heroPassed = !visible.has(cta) && cta.getBoundingClientRect().top < 0;
          bar.classList.toggle('is-visible', heroPassed && visible.size === 0);
        },
        { threshold: 0 }
      );
      ctas.forEach((el) => this.observer.observe(el));
    }
  }

  if (!customElements.get('sofaworx-sale-hero')) {
    customElements.define('sofaworx-sale-hero', SofaworxSaleHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-shop-the-range"] && !Shopify.designMode) return;
  try {
    
  /* Fabric swatch tiles — same behaviour as the collection card
     (sofaworx-card-swatches): selecting a tile swaps the card image and
     repoints the card links. The price is never swapped — cards always show
     the lowest ("From") price. */
  class SofaworxRangeSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('[data-range-card]');
      if (!this.card) return;
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-swatch]');
        if (swatch) this.select(swatch);
      });
      const base = this.card.querySelector('sofaworx-base-variants');
      if (base) {
        customElements.whenDefined('sofaworx-base-variants').then(() => base.prepare()).then(() => this.collapseIfTilesIdentical());
      } else {
        this.collapseIfTilesIdentical();
      }
    }

    /* The Mira sync can upload the SAME photo once per variant as separate
       Shopify files (distinct image ids/urls, identical pixels), so Liquid
       cannot tell a junk strip of duplicate thumbnails from a real fabric
       strip. Fetch each unique tile thumbnail (same-origin CDN, tiny,
       cache-friendly) and hide the strip when every tile is byte-identical. */
    async collapseIfTilesIdentical() {
      const tiles = this.querySelectorAll('[data-swatch]');
      const images = this.querySelectorAll('[data-swatch] img');
      // Fallback (no-image) tiles differentiate visually — leave those strips alone.
      if (tiles.length < 2 || images.length !== tiles.length) return;

      const urls = [...new Set([...images].map((img) => img.getAttribute('src')))];
      if (urls.some((url) => !url)) return;

      if (urls.length > 1) {
        if (!window.crypto?.subtle) return;
        try {
          const digests = await Promise.all(
            urls.map(async (url) => {
              const bytes = await (await fetch(url, { cache: 'force-cache' })).arrayBuffer();
              const hash = await crypto.subtle.digest('SHA-1', bytes);
              return Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, '0')).join('');
            })
          );
          if (new Set(digests).size > 1) return;
        } catch {
          return; // leave the strip visible if a tile can't be fetched
        }
      }

      // Inline style so it beats the class's display: flex.
      this.style.display = 'none';
    }

    select(swatch) {
      this.querySelectorAll('[data-swatch]').forEach((button) => {
        button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
      });

      const image = this.card.querySelector('[data-card-img]');
      if (image && swatch.dataset.image) {
        image.src = swatch.dataset.image;
        if (swatch.dataset.srcset) {
          image.srcset = swatch.dataset.srcset;
        } else {
          image.removeAttribute('srcset');
        }
      }

      // Price is intentionally NOT updated — cards always show the product's
      // lowest ("From") price regardless of which fabric is selected.

      if (swatch.dataset.variantUrl) {
        this.card.querySelectorAll('[data-card-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }
    }
  }
  if (!customElements.get('sofaworx-range-swatches')) {
    customElements.define('sofaworx-range-swatches', SofaworxRangeSwatches);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-support"] && !Shopify.designMode) return;
  try {
    
  // Support contact form → Mira lead proxy (same flow as Request-a-Quote):
  // the showroom KEY routes the mail to that showroom's inbox server-side,
  // with head office CC'd by the service. JS intercepts the native Shopify
  // contact submission; without JS the form still posts to Shopify.
  (function () {
    function getCookie(name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : undefined;
    }

    document.querySelectorAll('[data-support-lead]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      if (!form || form.dataset.swLeadHook === '1') return;
      form.dataset.swLeadHook = '1';

      var endpoint = wrap.dataset.endpoint || '/apps/mira/lead/request-quote';
      var successMessage = wrap.dataset.success || 'Thanks, your message has been sent.';
      var errorEl = form.querySelector('[data-form-error]');
      var submitBtn = form.querySelector('.sofaworx-support__submit');

      form.addEventListener('submit', function (e) {
        // Native validation first (required showroom / name / email).
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
          e.preventDefault();
          return;
        }
        e.preventDefault();

        var val = function (sel) {
          var el = form.querySelector(sel);
          return el && typeof el.value === 'string' ? el.value.trim() : '';
        };
        var subjectSel = form.querySelector('select[name="contact[subject]"]');
        var subjectLabel = '';
        if (subjectSel && subjectSel.selectedIndex > 0) {
          subjectLabel = subjectSel.options[subjectSel.selectedIndex].text.trim();
        }

        var body = {
          showroom: val('[data-showroom]'),
          company: val('[data-honeypot]'),
          first_name: val('input[name="contact[first_name]"]'),
          last_name: val('input[name="contact[last_name]"]'),
          email: val('input[name="contact[email]"]'),
          phone: val('input[name="contact[phone]"]'),
          message: val('textarea[name="contact[body]"]'),
          subject: subjectLabel,
          page_url: window.location.href,
          lead_source: 'contact',
          event_id:
            window.crypto && crypto.randomUUID
              ? crypto.randomUUID()
              : String(Date.now()) + Math.random().toString(16).slice(2),
          attribution: {
            fbp: getCookie('_fbp'),
            fbc: getCookie('_fbc'),
            user_agent: navigator.userAgent,
            referrer: document.referrer || undefined,
            landing_page: window.location.href
          }
        };

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        var originalLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            return res
              .json()
              .catch(function () { return null; })
              .then(function (data) {
                if (!res.ok || !data || !data.ok) {
                  throw new Error((data && data.error) || 'Request failed (' + res.status + ')');
                }
                var success = document.createElement('p');
                success.className = 'sofaworx-support__form-success';
                success.tabIndex = -1;
                success.textContent = successMessage;
                form.replaceChildren(success);
                requestAnimationFrame(function () { success.focus(); });
              });
          })
          .catch(function (err) {
            console.warn('[support] lead submit failed', err);
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalLabel;
            }
            if (errorEl) {
              errorEl.textContent =
                'Sorry, something went wrong sending your message. Please try again, or email us directly.';
              errorEl.hidden = false;
            }
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofaworx-swatches"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const root = document.getElementById('sw-swatches-root');
  if (!root) return;

  // ── Elements ─────────────────────────────────────────────
  const filterPanel = root.querySelector('[data-sw-filter-panel]');
  const filterToggle = root.querySelector('[data-sw-filter-toggle]');
  const filterClose = root.querySelector('[data-sw-filter-close]');
  const applyBtn = root.querySelector('[data-sw-apply]');
  const activeChipsEl = root.querySelector('[data-sw-active-chips]');
  const grid = root.querySelector('[data-sw-grid]');
  const countEl = root.querySelector('[data-sw-count]');
  const swatches = grid ? Array.from(grid.querySelectorAll('[data-sw-swatch]')) : [];

  // All search inputs (mobile bar + desktop panel both carry data-sw-search)
  const searchInputs = Array.from(root.querySelectorAll('[data-sw-search]'));

  // Accordion toggles
  const groupToggles = root.querySelectorAll('[data-sw-group-toggle]');

  // ── State ─────────────────────────────────────────────────
  let activeFilters = {}; // { group_id: Set<value> }
  let searchTerm = '';

  // ── Accordion ─────────────────────────────────────────────
  groupToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (panel) {
        if (expanded) {
          panel.hidden = true;
        } else {
          panel.hidden = false;
        }
      }
    });
  });

  // ── Filter chip clicks ─────────────────────────────────────
  root.querySelectorAll('[data-sw-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = chip.dataset.group;
      var value = chip.dataset.value;
      if (!activeFilters[group]) activeFilters[group] = new Set();
      if (activeFilters[group].has(value)) {
        activeFilters[group].delete(value);
        chip.classList.remove('is-active');
      } else {
        activeFilters[group].add(value);
        chip.classList.add('is-active');
      }
      renderActiveChips();
      applyFiltering();
    });
  });

  // ── Remove active chip ─────────────────────────────────────
  function removeFilter(group, value) {
    if (activeFilters[group]) {
      activeFilters[group].delete(value);
      if (activeFilters[group].size === 0) delete activeFilters[group];
    }
    // Sync chip button state
    root.querySelectorAll('[data-sw-chip][data-group="' + group + '"][data-value="' + value + '"]').forEach(function (c) {
      c.classList.remove('is-active');
    });
    renderActiveChips();
    applyFiltering();
  }

  function renderActiveChips() {
    if (!activeChipsEl) return;
    activeChipsEl.innerHTML = '';
    Object.keys(activeFilters).forEach(function (group) {
      activeFilters[group].forEach(function (value) {
        var btn = document.createElement('button');
        btn.className = 'sofaworx-swatches__active-chip';
        btn.textContent = value.replace(/-/g, ' ');
        btn.setAttribute('aria-label', 'Remove filter ' + value);
        var x = document.createElement('span');
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        btn.appendChild(x);
        btn.addEventListener('click', function () { removeFilter(group, value); });
        activeChipsEl.appendChild(btn);
      });
    });
  }

  // ── Apply button (noop in static mode — filtering is live) ─
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      closeMobileFilter();
    });
  }

  // ── Search ─────────────────────────────────────────────────
  searchInputs.forEach(function (input) {
    input.addEventListener('input', function () {
      searchTerm = input.value.toLowerCase().trim();
      // Keep other search inputs in sync
      searchInputs.forEach(function (other) {
        if (other !== input) other.value = input.value;
      });
      applyFiltering();
    });
  });

  // ── Filter logic ───────────────────────────────────────────
  function applyFiltering() {
    var hasFilters = Object.keys(activeFilters).some(function (g) { return activeFilters[g].size > 0; });
    var visible = 0;

    swatches.forEach(function (swatch) {
      var show = true;

      // Search match: check name + sub text
      if (searchTerm) {
        var nameEl = swatch.querySelector('.sofaworx-swatches__swatch-name');
        var subEl = swatch.querySelector('.sofaworx-swatches__swatch-sub');
        var text = ((nameEl ? nameEl.textContent : '') + ' ' + (subEl ? subEl.textContent : '')).toLowerCase();
        if (!text.includes(searchTerm)) show = false;
      }

      // Filter match: all active groups must match (AND logic)
      if (show && hasFilters) {
        Object.keys(activeFilters).forEach(function (group) {
          if (!show) return;
          var vals = activeFilters[group];
          if (vals.size === 0) return;
          var attr = swatch.dataset['colour'];
          if (group.indexOf('colour') !== -1 || group.indexOf('color') !== -1) attr = swatch.dataset['colour'];
          else attr = swatch.dataset['material'];
          if (!vals.has(attr)) show = false;
        });
      }

      if (show) {
        swatch.removeAttribute('data-sw-hidden');
        visible++;
      } else {
        swatch.setAttribute('data-sw-hidden', '');
      }
    });

    if (countEl) countEl.textContent = visible + ' swatches';
  }

  // ── Mobile filter panel ────────────────────────────────────
  function openMobileFilter() {
    if (!filterPanel) return;
    filterPanel.classList.add('is-mobile-open');
    if (filterClose) filterClose.style.display = 'flex';
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    var label = filterToggle && filterToggle.querySelector('[data-sw-filter-toggle-label]');
    if (label) label.textContent = 'Hide Filters';
    document.body.style.overflow = 'hidden';
  }

  function closeMobileFilter() {
    if (!filterPanel) return;
    filterPanel.classList.remove('is-mobile-open');
    if (filterClose) filterClose.style.display = 'none';
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    var label = filterToggle && filterToggle.querySelector('[data-sw-filter-toggle-label]');
    if (label) label.textContent = 'Show Filters';
    document.body.style.overflow = '';
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filterPanel && filterPanel.classList.contains('is-mobile-open');
      if (isOpen) { closeMobileFilter(); } else { openMobileFilter(); }
    });
  }

  if (filterClose) {
    filterClose.addEventListener('click', closeMobileFilter);
  }

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileFilter();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
